@if (showNote && isExisting != undefined) {
  <app-note-template-container
    size="sm"
    [isEditable]="_isNoteEditable"
    [isExistingNote]="isExisting"
    [isLoading]="isLoading"
    [noteForm]="noteForm"
    [noteDetail]="noteDetails"
    [showAuthor]="isExisting"
    [showSaveButton]="_isNoteEditable"
    [showCancelButton]="_isNoteEditable"
    [template]="template"
    (cancel)="onCancel()"
    (save)="onSave()"
  >
    <ng-template #template>
      <div [formGroup]="noteForm" class="p-fluid">
        <p-panel class="mb-4" header="Contact Information" toggler="header" [toggleable]="true" [collapsed]="false">
          <div class="grid grid-cols-2 gap-4">
            <div>
              <p class="font-semibold" [class]="{ 'field-required': _isNoteEditable }">Name:</p>
              @if (_isNoteEditable) {
                <div class="note-field-value">
                  <input class="w-full" type="text" pInputText formControlName="name"
                         [pTooltip]="noteForm?.value?.name" tooltipPosition="bottom" />
                </div>
              }
              @if (!_isNoteEditable) {
                <div class="note-field-value text-truncate block" [pTooltip]="noteForm?.value?.name"
                     tooltipPosition="bottom">
                  {{ noteForm?.value?.name }}
                </div>
              }
            </div>
            <div>
              <p class="font-semibold" [class]="{ 'field-required': _isNoteEditable }">Email:</p>
              @if (_isNoteEditable) {
                <div class="note-field-value">
                  <input class="w-full" type="text" pInputText formControlName="email"
                         [pTooltip]="noteForm?.value?.email" tooltipPosition="bottom" />
                </div>
              }
              @if (!_isNoteEditable) {
                <div class="note-field-value text-truncate block" [pTooltip]="noteForm?.value?.email"
                     tooltipPosition="bottom">
                  {{ noteForm?.value?.email }}
                </div>
              }
            </div>
            <div>
              <p class="font-semibold" [class]="{ 'field-required': _isNoteEditable }">Phone:</p>
              @if (_isNoteEditable) {
                <p-input-mask
                  styleClass="w-full"
                  mask="(999) 999-9999"
                  formControlName="phone"
                  [unmask]="true"
                  [autoClear]="false"
                  [pTooltip]="noteForm?.value?.phone"
                  tooltipPosition="bottom"
                />
              }
              @if (!_isNoteEditable) {
                <div class="note-field-value" [pTooltip]="noteForm?.value?.phone" tooltipPosition="bottom">
                  {{ noteForm?.value?.phone }}
                </div>
              }
            </div>
            <div>
              <p class="font-semibold">Ext:</p>
              @if (_isNoteEditable) {
                <input
                  class="w-full"
                  type="text"
                  pInputText
                  formControlName="ext"
                  [pTooltip]="noteForm?.value?.ext"
                  tooltipPosition="bottom"
                  maxlength="10"
                  pattern="[0-9]*"
                  inputmode="numeric"
                />
              }
              @if (!_isNoteEditable) {
                <div class="note-field-value" [pTooltip]="noteForm?.value?.ext" tooltipPosition="bottom">
                  {{ noteForm?.value?.ext }}
                </div>
              }
            </div>
          </div>
        </p-panel>

        <p-panel class="mb-4" header="Note Information" toggler="header" [toggleable]="true" [collapsed]="false">
          <div class="mb-4">
            <p class="font-semibold mb-4" [class]="{ 'field-required': _isNoteEditable }">Activity Type:</p>
            @if (_isNoteEditable) {
              <div class="flex flex-col gap-2">
                <div class="flex items-center">
                  <p-radioButton inputId="at-ac" name="activityType" formControlName="activityType"
                                 value="Account Activation" />
                  <label for="at-ac" class="ml-2">Account Activation</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="at-am" name="activityType" formControlName="activityType"
                                 value="Account Maintenance" />
                  <label for="at-am" class="ml-2">Account Maintenance</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="at-cdev" name="activityType" formControlName="activityType"
                                 value="Common Domain Email Verification" />
                  <label for="at-cdev" class="ml-2">Common Domain Email Verification</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="at-g" name="activityType" formControlName="activityType" value="General" />
                  <label for="at-g" class="ml-2">General</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="at-o" name="activityType" formControlName="activityType" value="Other" />
                  <label for="at-o" class="ml-2">Other</label>
                </div>
              </div>
            }
            @if (!_isNoteEditable) {
              <div class="note-field-value" [pTooltip]="noteForm?.value?.email" tooltipPosition="bottom">
                {{ noteForm?.value?.activityType }}
              </div>
            }
          </div>
          @if (noteForm.get('activityType')?.value === 'Other') {
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Other Activity
                Type:</p>
              <div class="p-field-value">
                <textarea
                  pInputTextarea
                  rows="1"
                  formControlName="otherActivityType"
                  class="w-full resize-y"
                  maxlength="500"
                ></textarea>
              </div>
            </div>
          }
          <div class="mb-4">
            <p class="mb-4 font-semibold" [class]="{ 'field-required': _isNoteEditable }">Request Source:</p>
            @if (_isNoteEditable) {
              <div class="flex flex-col gap-2">
                <div class="flex items-center">
                  <p-radioButton inputId="rq-ac" name="requestSource" formControlName="requestSource"
                                 value="Account Verification" />
                  <label for="rq-ac" class="ml-2">Account Verification</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="rq-email" name="requestSource" formControlName="requestSource"
                                 value="Email" />
                  <label for="av-email" class="ml-2">Email</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="rq-phone" name="requestSource" formControlName="requestSource"
                                 value="Phone" />
                  <label for="av-phone" class="ml-2">Phone</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="rq-ticket" name="requestSource" formControlName="requestSource"
                                 value="Ticket" />
                  <label for="rq-ticket" class="ml-2">Ticket</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton inputId="rq-other" name="requestSource" formControlName="requestSource"
                                 value="Other" />
                  <label for="rq-other" class="ml-2">Other</label>
                </div>
              </div>
            }
            @if (!_isNoteEditable) {
              <div class="note-field-value" [pTooltip]="noteForm?.value?.requestSource" tooltipPosition="bottom">
                {{ noteForm?.value?.requestSource }}
              </div>
            }
          </div>
          @if (noteForm.get('requestSource')?.value === 'Other') {
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Other Request
                Source:</p>
              <div class="p-field-value">
                <textarea
                  pInputTextarea
                  rows="1"
                  formControlName="otherRequestSource"
                  class="resize-y w-full"
                  maxlength="500"
                ></textarea>
              </div>
            </div>
          }
          <div class="mb-4">
            <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Date/Time Request Received:</p>
            @if (_isNoteEditable) {
              <div class="p-field-value">
                <p-date-picker
                  appendTo="body"
                  class="w-full"
                  hourFormat="12"
                  formControlName="requestDate"
                  placeholder="mm/dd/yyyy hh:mm:ss"
                  [panelStyle]="{ 'width': '360px' }"
                  [showIcon]="true"
                  [showTime]="true"
                  [showSeconds]="true"
                  [maxDate]="today"
                  [readonlyInput]="true"
                  [showOnFocus]="_isNoteEditable"
                  [showButtonBar]="true"
                />
              </div>
            }
            @if (!_isNoteEditable) {
              <div class="note-field-value" [pTooltip]="noteForm?.value?.requestDate" tooltipPosition="bottom">
                {{ noteForm?.value?.requestDate | date: 'MM/dd/yyyy hh:mm:ss a' }}
              </div>
            }
          </div>
          <div class="mg-4">
            <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Note:</p>
            @if (_isNoteEditable) {
              <div>
                  <textarea
                    rows="4"
                    pInputTextarea
                    formControlName="note"
                    maxlength="500"
                    class="w-full resize-y"
                  ></textarea>
                <div class="text-right">{{ charCount }}/500</div>
              </div>
            }
            @if (!_isNoteEditable) {
              <div>{{ noteForm?.value.note }}</div>
            }
          </div>
        </p-panel>

        @if (noteForm.get('activityType')?.value === 'Common Domain Email Verification') {
          <p-panel class="mb-4" header="Common Domain Email Verification" toggler="header" [toggleable]="true" [collapsed]="false">
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Was contact info validated on NPPES website?</p>
              <div class="p-field-value">
                @if (_isNoteEditable) {
                  <p-selectButton
                    [options]="YesNoOptions"
                    formControlName="infoValidated"
                    optionLabel="label"
                    optionValue="value"
                  />
                }
              </div>
              @if (!_isNoteEditable) {
                <div class="note-field-value" [pTooltip]="noteForm?.value?.infoValidated ? 'Yes' : 'No'"
                     tooltipPosition="bottom">
                  {{ noteForm?.value?.infoValidated == 'true' ? 'Yes' : 'No' }}
                </div>
              }
            </div>
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Outreach Attempt:</p>
              <div class="p-field-value">
                @if (_isNoteEditable) {
                  <p-selectButton
                    [options]="outreachAttempt"
                    formControlName="outreachAttempt"
                    optionLabel="label"
                    optionValue="value"
                  />
                }
                @if (!_isNoteEditable) {
                  <div class="note-field-value" [pTooltip]="noteForm?.value?.outreachAttempt" tooltipPosition="bottom">
                    {{ noteForm?.value?.outreachAttempt }}
                  </div>
                }
              </div>
            </div>
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Date Of Outreach Attempt:</p>
              @if (_isNoteEditable) {
                <div class="p-field-value">
                  <p-date-picker
                    appendTo="body"
                    class="w-full"
                    hourFormat="12"
                    formControlName="outreachAttemptDate"
                    placeholder="mm/dd/yyyy hh:mm:ss"
                    [panelStyle]="{ 'width': '360px' }"
                    [showIcon]="true"
                    [showTime]="true"
                    [showSeconds]="true"
                    [readonlyInput]="!_isNoteEditable"
                    [showOnFocus]="_isNoteEditable"
                    [showButtonBar]="true"
                  />
                </div>
              }
              @if (!_isNoteEditable) {
                <div class="note-field-value" [pTooltip]="noteForm?.value?.outreachAttemptDate"
                     tooltipPosition="bottom">
                  {{ noteForm?.value?.outreachAttemptDate | date: 'MM/dd/yyyy hh:mm:ss a' }}
                </div>
              }
            </div>
            <div class="mb-4">
              <p class="font-semibold mb-2">Were you able to validate the following information?</p>
              @if (_isNoteEditable) {
                <div class="p-field-value">
                  <div class="flex flex-col gap-4" formArrayName="validatedItems">
                    @for (item of validationItems; track item; let i = $index) {
                      <div class="flex items-center">
                        <p-checkbox [inputId]="item.label" [formControlName]="i" [binary]="true" />
                        <label [for]="item.label" class="ml-2">{{ item.label }}</label>
                      </div>
                    }
                  </div>
                </div>
              }
              @if (!_isNoteEditable) {
                <div>
                  @if (hasValidatedItems) {
                    <ul>
                      @for (item of validationItems; track item) {
                        @if (noteForm.value.validatedItems?.includes(item.value)) {
                          <li>
                            {{ item.label || "--" }}
                          </li>
                        }
                      }
                    </ul>
                  } @else {
                    <span>--</span>
                  }
                </div>
              }
            </div>
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Confirmed user name and access needed:</p>
              @if (_isNoteEditable) {
                <div>
                    <textarea
                      rows="4"
                      pInputTextarea
                      formControlName="administratorName"
                      maxlength="500"
                      class="w-full resize-y"
                    ></textarea>
                  <div class="text-right">{{ characterCount }}/500</div>
                </div>
              }
              @if (!_isNoteEditable) {
                <div>
                  {{ noteForm?.value.administratorName }}
                </div>
              }
            </div>
            <div class="mb-4">
              <p class="font-semibold mb-2" [class]="{ 'field-required': _isNoteEditable }">Were you able to verify the account?</p>
              <div class="p-field-value">
                @if (_isNoteEditable) {
                  <p-selectButton
                    [options]="YesNoOptions"
                    formControlName="verifyAccount"
                    optionLabel="label"
                    optionValue="value"
                  />
                }
              </div>
              @if (!_isNoteEditable) {
                <div class="note-field-value" [pTooltip]="noteForm?.value?.verifyAccount ? 'Yes' : 'No'"
                     tooltipPosition="bottom">
                  {{ noteForm?.value?.verifyAccount == 'true' ? 'Yes' : 'No' }}
                </div>
              }
            </div>
            @if (noteForm.get('verifyAccount')?.value === true || noteForm.get('verifyAccount')?.value === 'true') {
              <div class="field">
                <strong [class]="{ 'field-required': _isNoteEditable }">Date Verified:</strong>
                @if (_isNoteEditable) {
                  <div class="p-field-value">
                    <p-date-picker
                      formControlName="verifiedDate"
                      appendTo="body"
                      class="w-full"
                      [showIcon]="true"
                      [showTime]="true"
                      [showSeconds]="true"
                      hourFormat="12"
                      [readonlyInput]="true"
                      placeholder="mm/dd/yyyy hh:mm:ss"
                      [panelStyle]="{ 'width': '360px' }"
                      [maxDate]="today"
                      [showButtonBar]="true"
                    />
                  </div>
                }
                @if (!_isNoteEditable) {
                  <div class="note-field-value" [pTooltip]="noteForm?.value?.verifiedDate" tooltipPosition="bottom">
                    {{ noteForm?.value?.verifiedDate | date: 'MM/dd/yyyy hh:mm:ss a' }}
                  </div>
                }
              </div>
            }
          </p-panel>
        }
      </div>
      <br>
    </ng-template>
  </app-note-template-container>
}
